// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"4a750e7d","815":"e1abd1ab"}[chunkId] + ".chunk.js";
};